var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVector = function SvgVector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    fill: "none",
    viewBox: "0 0 20 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E6DE5",
    d: "m19.158 12.643-5.912-9.854C12.47 1.496 11.283.756 9.987.756s-2.483.74-3.259 2.03L.816 12.644c-.786 1.309-.872 2.705-.235 3.83.636 1.126 1.878 1.772 3.406 1.772h12c1.528 0 2.77-.646 3.406-1.771s.551-2.521-.235-3.831m-9.17 2.15c-.855 0-1.55-.694-1.55-1.548s.694-1.551 1.55-1.551c.854 0 1.55.696 1.55 1.55s-.697 1.55-1.55 1.55M11.62 7.37c-.01.03-1.4 3.468-1.4 3.468a.25.25 0 0 1-.232.156.25.25 0 0 1-.23-.156L8.365 7.4a1.8 1.8 0 0 1-.129-.655c0-.965.785-1.75 1.75-1.75A1.752 1.752 0 0 1 11.62 7.37"
  })));
};
export { SvgVector as ReactComponent };
export default "/_next/static/media/static/media/Vector.e6f0450d3a2476e50cd769d3ee3a1228svg";